import React, { useMemo } from "react";
import { useTranslations } from "../i18n/useTranslations";
import { getDiscoverMore } from "./data";

export const DiscoverSection = () => {
  const { t, lang } = useTranslations();
  const discoverMore = useMemo(() => getDiscoverMore(lang), [lang]);

  return (
    <>
      <div
        role="heading"
        className="elm-text-dd-gray-900 elm-font-sans elm-text-sm elm-font-normal elm-uppercase elm-m-0 elm-mb-3"
      >
        {t("Trending")}
      </div>
      <div className="elm-m-0 elm-p-0 elm-grid elm-grid-flow-row elm-gap-2 elm-list-none w-full elm-flex-grow">
        {discoverMore.map((item, index) => (
          <a
            href={item.href}
            key={index}
            className="elm-w-full elm-flex elm-no-underline elm-text-dd-gray-900 elm-font-sans elm-text-base elm-font-semibold elm-px-2 elm-rounded-xl elm-border-gray-200 elm-bg-dd-blue-50 elm-leading-5"
          >
            <div className="elm-flex-none elm-w-1/3 md:elm-w-28 lg:elm-w-36 elm-flex">
              <img src={item.imageSrc} className="elm-w-full elm-self-end" />
            </div>
            <div className="elm-self-center elm-px-4 md:elm-px-6">{item.title}</div>
          </a>
        ))}
      </div>
    </>
  );
};
